import React, { Component } from 'react';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import ConditionedComponent from 'components/ConditionedComponent.js';
import PresetsCache from 'decentralized/presets/PresetsCache.js';
import {FM_SYNTH} from 'constants/instrument-types.js';

const PAGE_SIZE = 10;

const presetsCache = new PresetsCache();

class FMGenetix extends Component {
    constructor(props) {
        super(props);

        this.state = {
            presets: [],
            start: 0,
            loading: false,
            loadingCounter: 0,
            probability: 0.5,
            crossbreedEffects: true,
        };

        this.getPresets();

        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrevious = this.onClickPrevious.bind(this);
    }

    onClickNext() {
        this.state.start = this.state.start + PAGE_SIZE;
        this.getPresets();
    }

    onClickPrevious() {
        this.state.start = Math.max(0, this.state.start - PAGE_SIZE);
        this.getPresets();
    }

    startLoading() {
        this.setState({loading: true});
        this.loadingTimer = setInterval(() => {
            this.setState({loadingCounter: (this.state.loadingCounter + 1) % 5});
        }, 200);
    }

    stopLoading() {
        this.setState({loading: false});
        clearInterval(this.loadingTimer);
    }

    async getPresets() {
         let filter = {
             instrumentTypes: {},
             tags: {},
        };
        filter.instrumentTypes[this.props.track.instrument.getInstrumentType()] = true;
        let ret = await presetsCache.getPaginatedPresets(filter, this.state.start);
        
        this.setState({presets: ret});
    }

    onUpdateProbability(probability) {
        this.setState({
            probability: probability / 100.0
        });
    }

    async onClickPreset(preset) {
        this.startLoading();
        await this.props.track.mateWithPreset(
            preset,
            this.state.probability,
            this.state.crossbreedEffects);
        this.stopLoading();
    }

    getEffectsClassName(isYes) {
        return this.state.crossbreedEffects === isYes ? "crossbreed-option enabled" : "crossbreed-option";
    }

    onClickEffects(isYes) {
        this.setState({
            crossbreedEffects: isYes
        });
    }

    render() {
        let str = '';
        for (let i=0; i < this.state.loadingCounter; i++) {
            str += '.'
        }
        return (
            <div className="fm-genetix">
              <div onClick={this.props.onClickBack} className="back-button">Back</div>
              <ConditionedComponent condition={this.state.loading}>
                <div className="loading-spinner">Loading {str} </div>
              </ConditionedComponent>
              <ConditionedComponent condition={!this.state.loading}>
                <div className="crossbreed-options">
                  <div>
                    <div className="crossbreed-probability">
                      Crossbreed Preset: {this.state.probability * 100}%
                    </div>
                    <ReactBootstrapSlider
                      value={this.state.probability * 100}
                      change={(e) => this.onUpdateProbability(e.target.value)}
                      step={0.01}
                      max={100}
                      min={0}
                      orientation="horizontal"
                      reversed={false}
                      />
                    </div>
                    <div>
                      Crossbreed Effects:
                      <span
                        onClick={() => this.onClickEffects(true)}
                        className={this.getEffectsClassName(true)}>
                        Yes
                      </span>
                      <span
                        onClick={() => this.onClickEffects(false)}
                        className={this.getEffectsClassName(false)}>
                        No
                      </span>
                    </div>
                </div>
 
              <div className="presets">
                {this.state.presets.map(
                    (preset, i) =>
                        <div
                              onClick={() => this.onClickPreset(preset)}
                              className={i % 2 === 0 ? "preset" : "preset odd"}>
                          {preset.title}</div>)}
              </div>
              <div className="pagination-buttons">
                <ConditionedComponent condition={this.state.start > 0}>
                  <div onClick={this.onClickPrevious} className="pagination-button">PREVIOUS</div>
                </ConditionedComponent>
                <div onClick={this.onClickNext} className="pagination-button">
                  NEXT
                </div>
              </div>
            </ConditionedComponent>
          </div>
        );
    }
}

export default FMGenetix;
